import { Component, computed, inject, input, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { isPlatformBrowser, CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ProductsLookupService } from '../../../../services/product/lookup.service';
import { Company } from './view-company.model';
import { LanguageService } from '../../../../services/language.service';
import { LookupResultSet, LookupVTO } from '../../../../pages/admin-dashboard/admin-companies/admin-companies.model';

@Component({
  selector: 'app-view-company',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './view-company.html',
  styleUrl: './view-company.scss',
})
export class ViewCompany implements OnInit {
  id = input<string>();
  private lookupService = inject(ProductsLookupService);
  private platformId = inject(PLATFORM_ID);
  private languageService = inject(LanguageService);

  company = signal<Company | undefined>(undefined);
  loading = signal<boolean>(true);
  error = signal<string | null>(null);
  categories = signal<LookupResultSet | undefined>(undefined);
  subCategories = signal<LookupResultSet | undefined>(undefined);

  filters = {
    productName: '',
    categoryId: undefined,
    subCategoryId: undefined,
    mfgCompany: undefined as any,
    peoplePriceFrom: 0,
    peoplePriceTo: 0,
    pharmacyPriceFrom: 0,
    pharmacyPriceTo: 0,
    orderBy: 'productName',
    orderDir: 'ASC',
  };

  products = signal<any[]>([
    {
      id: 1,
      name: 'Panadol Comp - 500 mg/65 mg',
      image: '/assets/product.png',
      manufacturer: 'GSK',
      expires: '08/27',
      discount: 10,
      pharmacyPrice: 50,
      peoplePrice: 70,
    },
    {
      id: 2,
      name: 'Aspirin Protect 100mg',
      image: '/assets/product.png',
      manufacturer: 'Bayer',
      expires: '12/26',
      discount: 0,
      pharmacyPrice: 45,
      peoplePrice: 60,
    },
    {
      id: 3,
      name: 'Brufen 400mg',
      image: '/assets/product.png',
      manufacturer: 'Abbott',
      expires: '05/26',
      discount: 15,
      pharmacyPrice: 30,
      peoplePrice: 40,
    },
    {
      id: 4,
      name: 'Voltaren Emulgel',
      image: '/assets/product.png',
      manufacturer: 'Novartis',
      expires: '01/26',
      discount: 5,
      pharmacyPrice: 80,
      peoplePrice: 100,
    },
  ]);

  currentPage = signal<number>(1);
  pageSize = signal<number>(8);

  paginatedProducts = computed(() => {
    const startIndex = (this.currentPage() - 1) * this.pageSize();
    return this.products().slice(startIndex, startIndex + this.pageSize());
  });

  totalPages = computed(() => Math.ceil(this.products().length / this.pageSize()));

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      const storedCompany = sessionStorage.getItem('selectedCompany');
      if (storedCompany) {
        const compData = JSON.parse(storedCompany);
        this.company.set(compData);
        this.filters.mfgCompany = compData.id;
        this.loading.set(false);
        this.loadFilterOptions();
      } else {
        this.error.set('No company data found.');
        this.loading.set(false);
      }
    }
  }

  loadFilterOptions() {
    this.lookupService.getLookupCategories().subscribe((res) => {
      this.categories.set(res);
      this.subCategories.set(res);
    });
  }

  getSliderTrackStyle(from: number, to: number) {
    const min = 0;
    const max = 1000;
    const start = ((from - min) / (max - min)) * 100;
    const end = ((to - min) / (max - min)) * 100;
    return {
      background: `linear-gradient(to right, #e5e7eb ${start}%, #C42727 ${start}%, #C42727 ${end}%, #e5e7eb ${end}%)`,
    };
  }

  getLocalizedTitle(item: Company | LookupVTO | undefined): string {
    if (!item) return '';
    if ('titleEn' in item) {
      return this.languageService.getCurrentLocale() == 'ar' ? item.titleAr || item.titleEn : item.titleEn;
    }
    return item.name;
  }

  getLocalizedSortOrder(): string {
    const isAr = this.languageService.getCurrentLocale() == 'ar';
    return this.filters.orderDir == 'ASC' ? (isAr ? 'تصاعدي' : 'ASC') : isAr ? 'تنازلي' : 'DESC';
  }

  validateRange(type: 'people' | 'pharmacy') {
    if (type === 'people') {
      if (this.filters.peoplePriceFrom > this.filters.peoplePriceTo) {
        this.filters.peoplePriceFrom = this.filters.peoplePriceTo;
      }
    } else {
      if (this.filters.pharmacyPriceFrom > this.filters.pharmacyPriceTo) {
        this.filters.pharmacyPriceFrom = this.filters.pharmacyPriceTo;
      }
    }
  }

  toggleSortOrder() {
    this.filters.orderDir = this.filters.orderDir == 'ASC' ? 'DESC' : 'ASC';
    this.applyFilters();
  }

  applyFilters() {
    console.log(this.filters);
  }

  resetFilters() {
    this.filters = {
      productName: '',
      categoryId: undefined,
      subCategoryId: undefined,
      mfgCompany: this.company()?.id,
      peoplePriceFrom: 0,
      peoplePriceTo: 0,
      pharmacyPriceFrom: 0,
      pharmacyPriceTo: 0,
      orderBy: 'productName',
      orderDir: 'ASC',
    };
    this.applyFilters();
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages()) {
      this.currentPage.set(page);
    }
  }

  get pagesArray() {
    return Array(this.totalPages())
      .fill(0)
      .map((x, i) => i + 1);
  }

  onAddToWishlist(product: any) {}
  onAddToCart(product: any) {}
}
